export const setToastDisplayAction = (state,action) =>{ 
	state.showToast = action.payload;
}
export const setToastDataAction = (state,action) =>{ 
	state.toastData = action.payload;
	state.showToast = true;
}
export const ConfirmationToggleAction = (state,action) =>{
	state.confirmDisplay = action.payload
}
export const ConfirmationDataAction = (state,action) =>{
	state.confirmDisplay = true;
	state.confirmationData = action.payload;
}